/* ============================================================
   sb-brevo.js — Brevo Conversations hinter der Einwilligung
   ============================================================
   Ersetzt den Inline-Block, der bis zum 14.09.2026 in
   layout/theme.liquid stand (zwei Tags: der Loader fuer
   brevo-conversations.js und static/js/shopify.js). Der Chat
   setzt Cookies und LocalStorage auf beiden Origins und ist
   damit nicht notwendig im Sinne des TDDDG — er haengt jetzt an
   der Kategorie Komfort (p = 1).

   Die BrevoConversationsID ist unveraendert aus dem alten
   Inline-Block uebernommen. Sie ist eine oeffentliche
   Widget-Kennung, kein Geheimnis.

   ── Reihenfolge ──
   Dieses Skript steht in theme.liquid vor dem Banner-Snippet,
   beide mit defer; es laeuft also VOR sb-consent.js und
   registriert den Listener rechtzeitig. Der zusaetzliche
   SBConsent-Griff unten macht die Datei trotzdem
   reihenfolgefrei — wer die Einbindung verschiebt, bricht
   nichts.
   ============================================================ */

(function () {
  'use strict';

  var WIDGET_ID = '666a8b8e14b2633e0414b400';
  var SRC_WIDGET = 'https://conversations-widget.brevo.com/brevo-conversations.js';
  var SRC_SHOPIFY = 'https://conversations-widget.brevo.com/static/js/shopify.js';

  var loaded = false;

  function append(src) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    (document.head || document.documentElement).appendChild(s);
  }

  function load() {
    if (loaded) return;
    loaded = true;

    window.BrevoConversationsID = WIDGET_ID;
    // Queue-Stub aus dem alten Inline-Block: Aufrufe vor dem Laden des
    // Bundles landen in .q und werden danach abgespielt.
    window.BrevoConversations =
      window.BrevoConversations ||
      function () {
        (window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments);
      };

    append(SRC_WIDGET);
    append(SRC_SHOPIFY);
  }

  function check(rec) {
    if (rec && rec.p === 1) load();
  }

  document.addEventListener('sb:consent', function (e) {
    check(e.detail);
  });

  if (window.SBConsent && typeof window.SBConsent.get === 'function') {
    check(window.SBConsent.get());
  }
})();
